import colors from '../../constants/js/colors.js';
import { textSizeStyles } from '../../mixins/text/textSizeWeight';
import border from '../../constants/js/border.js';
import indents from '../../constants/js/indents.js';
export const constantSize = {
  fs16: {
    textSize: textSizeStyles('fs16'),
    width: '24px',
    height: '24px',
    borderRadius: border.borderRadius,
    paddingBordered: indents.indentM,
    marginTopIcon: '0px'
  },
  fs14: {
    textSize: textSizeStyles('fs14'),
    width: '16px',
    height: '16px',
    borderRadius: border.borderRadiusSmall,
    paddingBordered: indents.indentS,
    marginTopIcon: '2px'
  },
  fs12: {
    textSize: textSizeStyles('fs12'),
    width: '16px',
    height: '16px',
    borderRadius: border.borderRadiusSmall,
    marginTopIcon: '0px'
  }
};
export const defaultThemeCheckbox = {
  Checkbox: {
    state: {
      default: {
        colorIcon: 'transparent',
        borderColor: colors.majorGray,
        color: colors.minorDarkBlue,
        bg: 'transparent'
      },
      hover: {
        borderColor: colors.majorBlue
      },
      error: {
        borderColor: colors.majorRed
      },
      checked: {
        colorIcon: colors.majorWhite,
        borderColor: colors.majorBlue,
        bg: colors.majorBlue
      },
      disabled: {
        colorIcon: colors.silverTrans7,
        borderColor: colors.grayTrans1,
        color: colors.silverTrans7,
        bg: colors.majorWhite
      },
      checkedDisabled: {
        colorIcon: colors.silverTrans7,
        borderColor: colors.minorGrayLighten,
        bg: colors.majorWhite
      }
    }
  }
};